/** Clé provide/inject : profil client.type_offre depuis DashboardLayout (évite courses avec le fetch du Dashboard). */
export const MODULE1_CLIENT_OFFER_KEY = Symbol('module1ClientOffer');

/** Clé provide/inject : formule basique | premium (teasers réservés à premium). */
export const MODULE1_CLIENT_FORMULE_KEY = Symbol('module1ClientFormule');
